import { useSelector } from "react-redux";
import { evaluateDitsMenuItemPriceV2 } from "../../helpers/ditsMenuItemHelper";
import { formatPrice } from "../../helpers/formatHelper";
import { LocalizerHelper } from "../../helpers/localizerHelper";
import { DELIVERY_MODES } from "../../constants/data";
import { RootState } from "../../store";
import './index.scss';
import { SessionMenuItem } from "../../models/session";
import { OrderRecapButton } from "./OrderRecapButton";

interface BottomOrderRecapProps {
    goToNext: () => void;
    disableLabel?: string|null;
    nextLabel: string;
    disableAction?: boolean;
    addDeliveryCosts?: boolean;
}

const BottomOrderRecap: React.FC<BottomOrderRecapProps> = ({
    goToNext,
    nextLabel,
    disableAction = false,
    addDeliveryCosts = false,
    disableLabel
}) => {
    const restaurant = useSelector((state: RootState) => state.restaurant.restaurant);
    const dits = useSelector((state: RootState) => state.session.session);
    const sessionMenuItems = useSelector((state: RootState) => state.session.menuItems);

    // Calculate total price
    let totalPrice = sessionMenuItems.reduce((acc: number, item: SessionMenuItem) => acc + evaluateDitsMenuItemPriceV2(item), 0);

    if (addDeliveryCosts && dits?.delivery_mode === DELIVERY_MODES.delivery) {
        const deliveryCost = dits?.delivery_details?.preview_delivery_cost ?? 0;
        const freeDeliveryMinimum = restaurant?.free_delivery_minimum_amount ?? 0;
        const mustApplyDeliveryCost = deliveryCost > 0 ? (freeDeliveryMinimum > 0 ? totalPrice < freeDeliveryMinimum : true) : false;
        if (mustApplyDeliveryCost) totalPrice += deliveryCost;
    }

    // Show free delivery message if applicable
    const renderDeliveryMessage = () => {
        if(!!disableLabel && disableLabel?.trim().length > 0){
            return <p>{disableLabel}</p>
        }
        
        if (dits?.delivery_mode === DELIVERY_MODES.delivery && restaurant?.free_delivery_minimum_amount) {
            const freeDeliveryMinimum = restaurant?.free_delivery_minimum_amount;
            if (totalPrice < freeDeliveryMinimum) {
                return <p>{LocalizerHelper.localized('bottom_order_recap_free_delivery_minimum_amount')} {formatPrice(freeDeliveryMinimum)}</p>;
            }
        }
        return null;
    };

    return (
        <div className="bottom-fixed-row order-recap-fixed-row">
            <div>
                {renderDeliveryMessage()}
                <OrderRecapButton
                    totalPrice={totalPrice}
                    goToNext={goToNext}
                    nextLabel={nextLabel}
                    disableAction={disableAction}
                />
            </div>
        </div>
    );
};

export default BottomOrderRecap;
